import Vue from "vue";

Vue.component("parties-multiselect", {
	props: [
		"value",
		"dynamicValue",
		"language",
		"disabled",
		"selectAll",
		"excludeWto"
	],
	data() {
		return {
			loading: false,
			myValue: [],
			filteredParties: [],
			parties: [],
			initializing: false,
			loadingText: window.labels.loading,
			isDisabled: this.disabled
		}
	},
	methods: {
		getFilteredMembers(text) {
			this.filteredParties = this.parties.filter((member) => {
				return member.text
					.toString()
					.toLowerCase()
					.indexOf(text.toLowerCase()) >= 0
			})
		}
	},
	watch: {
		selectAll: function (val) {
			
			if (val == true) {
				this.myValue = [];
				this.parties.forEach(member => {
					this.myValue.push(member);

				});
			} else {
				this.myValue = [];
			}
		},
		
		myValue: function (value) {
			let tempValue = [];
			value.forEach(member => {
				tempValue.push(member.id);
			});

			this.$emit("update:value", tempValue);
		},
		dynamicValue: function(value) {
			if (value.length > 0) {
				this.myValue = [];
				value.forEach(memberId => {
					var items = this.parties.filter(member => member.id == memberId);
					if (items.length > 0) {
						this.myValue.push(items[0]);
					}
				});
			}
			else {
				this.myValue = [];
			}
		}
	},
	mounted() {
		const self = this;

		self.loading = true;
		self.isDisabled = false;
		self.$services.parties.getDropdownItems({
			language: self.language,
			published: true,
			IncludeWTO: !this.excludeWto 
		})
			.then((data) => {
				self.loading = false;
				console.log(this.excludeWto)
				if (this.excludeWto) {
					self.parties = data.filter((x) => x.id != "A000");
					self.filteredParties = data.filter((x) => x.id != "A000");

				} else {
					self.parties = data;
					self.filteredParties = data;

				}
				if (self.value && self.value.length > 0) {
					self.value.forEach(memberId => {
						var items = data.filter(member => member.id == memberId);
						if (items.length > 0) {
							self.myValue.push(items[0]);
						}
					});
				}

				if (this.selectAll == true) {
					this.myValue = [];
					this.parties.forEach(member => {
						this.myValue.push(member);

					});
				} else if(!this.selectAll && !(self.value && self.value.length > 0)){
					this.myValue = [];
				}
			});
	},
	template: `
		<div>
		<div v-if="loading">
			<loading :loading-text="loadingText"></loading>
		</div>
		<div v-else>
			<div v-if="selectAll">
						<b-taginput
				disabled
				ref="partyMultiselect"
				autocomplete
				v-model="myValue"
				:data="filteredParties"
				@typing="getFilteredMembers"
				field="text"
				:open-on-focus="true"
				append-to-body
			>
			</b-taginput>
			</div>
			<div v-else>
						<b-taginput
						ref="partyMultiselect"
				autocomplete
				v-model="myValue"
				:data="filteredParties"
				@typing="getFilteredMembers"
				field="text"
				:open-on-focus="true"
				append-to-body
			>
			</b-taginput>
			</div>
	
		</div>
		</div>
	`
});